// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Xq8K","name":"Header_name__2qdZl","birthday":"Header_birthday__3Nnyd","skeleton":"Header_skeleton__bzaJ3"};